import { LoginAction, LoginStatus, useLoginStatus } from './useLoginStatus';
import { useLoginToken } from './useLoginToken';
import { LoginRequestData } from '../../rest/LoginRequestData';
import { useForm } from 'react-hook-form';
import { useLoginRequest } from './useLoginRequest';
import { useOtp } from '../shared/otp/useOtp';
import { useNavigate } from 'react-router-dom';
import { UrlsFront } from '../../constants/urls';
import { useErrorMessage } from '../shared/useErrorMessage';
import { LOGIN_DEFAULT_ERROR_MESSAGE } from '../../constants/data';
import { axiosMessageExtractor } from '../../config/axiosMessageExtractor';

export const useLoginManager = () => {
  const [status, dispatch, isLoading, isRequestError, showEmail, showTokenInput, showConfirmButton, emailBlocked] = useLoginStatus();
  const [requestErrorMessage, setRequestErrorMessage, , clearRequestErrorMessage] = useErrorMessage(axiosMessageExtractor, LOGIN_DEFAULT_ERROR_MESSAGE);
  const [otpInput, setOtpInput, validateOTP, resetOtp, showErrorOtp] = useOtp();
  const [loginToken, setLoginToken, checkLoginToken, resetLoginToken] = useLoginToken();
  const navigate = useNavigate();

  const form = useForm<LoginRequestData>({ mode: 'onBlur', defaultValues: { email: '', googleToken: '' } });
  const getEmail = () => form.getValues('email');

  function reset() {
    resetOtp();
    form.reset();
    resetLoginToken();
    clearRequestErrorMessage();

    dispatch(LoginAction.REINICIAR);
  }

  function finishLogin() {
    reset();
    navigate(UrlsFront.FixedTerms);
  }

  const [request1, request2] = useLoginRequest(
    showTokenInput,
    dispatch,
    setRequestErrorMessage,
    clearRequestErrorMessage,
    getEmail,
    otpInput,
    loginToken,
    setLoginToken,
    finishLogin
  );

  const validateForm = async () => {
    if (status === LoginStatus.EMAIL || status === LoginStatus.ERROR_EMAIL_STATUS) return await form.trigger();

    return validateOTP();
  };

  function onError(reason?: any) {
    dispatch(LoginAction.ERROR);
    setRequestErrorMessage(reason);
  }

  async function confirm() {
    if (!(await validateForm())) {
      clearRequestErrorMessage();
      return;
    }

    try {
      switch (status) {
        case LoginStatus.EMAIL:
        case LoginStatus.ERROR_EMAIL_STATUS: {
          dispatch(LoginAction.CONTINUAR);
          request1();
          break;
        }
        case LoginStatus.TOKEN:
        case LoginStatus.ERROR_TOKEN_STATUS: {
          if (!checkLoginToken()) {
            reset();
            return;
          }
          dispatch(LoginAction.CONTINUAR);
          request2();
          resetOtp();
          break;
        }
      }
    } catch (ex) {
      onError();
    }
  }

  return [isLoading, isRequestError, requestErrorMessage, emailBlocked, showEmail, showTokenInput, showConfirmButton, confirm, otpInput, setOtpInput, showErrorOtp, form] as const;
};
